import { AbstractControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

// No spaces, max 18 characters, no special characters except hyphen, not text only
const meternumberPattern = /^(?=.*\d)[A-Za-z0-9-]{1,18}$/;

/**
 * Validates a meternumber
 * @returns {(control: AbstractControl) => {[p: string]: string}}
 * @param control
 * @param errorText
 */
export function meternumberValidator(translateService: TranslateService, errorText?: string) {
  return (control: AbstractControl): { [key: string]: string | true } | null => {
    const regex = RegExp(meternumberPattern);
    if (!control.value) {
      return null;
    }

    errorText = errorText ? errorText : translateService.instant('meterreadings.validator.meternumber');

    if (!regex.test(control?.value)) {
      return { ['meternumber']: (errorText ? errorText : true) };
    }
    return null;
  };
}
